import { render, staticRenderFns } from "./medkon_tren_group_topik.vue?vue&type=template&id=58b51d74"
import script from "./medkon_tren_group_topik.vue?vue&type=script&lang=js"
export * from "./medkon_tren_group_topik.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports